<template>
  <drag-dialog
    v-model:visible="dialogVisible"
    :right="25"
    :top="3.8"
    :width="18.1875"
    :height="29"
    title="状态信息"
  >
    <div class="container">
      <div class="box">
        <p class="item-title">无人机信息</p>
        <div class="common-item">
          <p>无人机型号:</p>
          <p>{{ UAVModel ? UAVModel : "-" }}</p>
        </div>
        <div class="common-item">
          <p>RTK就绪状态:</p>
          <p>{{ uavInfo.rtkStatusName ? uavInfo.rtkStatusName : "-" }}</p>
        </div>
        <div class="common-item">
          <p>卫星数:</p>
          <p>
            {{
              typeof uavInfo.rtkSatCount !== "undefined"
                ? uavInfo.rtkSatCount
                : "-"
            }}
          </p>
        </div>
        <div class="common-item">
          <p>RTK状态:</p>
          <p>
            {{
              typeof uavInfo.rtkReady !== "undefined"
                ? uavInfo.rtkReady === true
                  ? "已就绪"
                  : "未就绪"
                : "-"
            }}
          </p>
        </div>
        <div class="common-item">
          <p>经度:</p>
          <p>{{ uavInfo.afLong ? uavInfo.afLong : "-" }}</p>
        </div>
        <div class="common-item">
          <p>纬度:</p>
          <p>{{ uavInfo.afLat ? uavInfo.afLat : "-" }}</p>
        </div>
        <div class="common-item">
          <p>航向:</p>
          <p>
            {{
              typeof uavInfo.flyDirection !== "undefined"
                ? uavInfo.flyDirection + "°"
                : "-"
            }}
          </p>
        </div>
        <div class="common-item">
          <p>云台角度:</p>
          <p>
            {{
              typeof uavInfo.cameraPitch !== "undefined"
                ? uavInfo.cameraPitch + "°"
                : "-"
            }}
          </p>
        </div>
        <div class="common-item">
          <p>电量:</p>
          <p>
            {{ typeof uavInfo.charge !== "undefined" ? uavInfo.charge : "-" }}
          </p>
        </div>
        <div class="common-item flex-a">
          <p>RCLTE:</p>
          <div
            class="signal-wrapper"
          >
            <span v-show="uavInfo.rcLte===0||uavInfo.rcLte===undefined" class="iconfont icon-guanbi1 close flex-fac"></span>
            <ul>
              <li
                v-for="i in 5"
                :key="i"
                :style="{
                  background:
                    '' + (i <= 0 ? '#5cf548' : 'rgba(0, 0, 0, 0.4)') + ''
                }"
              ></li>
            </ul>
          </div>
        </div>
        <div class="common-item flex-a">
          <p>UAVLTE:</p>
          <div
            class="signal-wrapper"
          >
            <span v-show="uavInfo.uavLte===0||uavInfo.uavLte===undefined" class="iconfont icon-guanbi1 close flex-fac"></span>
            <ul>
              <li
                v-for="i in 5"
                :key="i"
                :style="{
                  background:
                    '' + (i <= uavInfo.uavLte ? '#5cf548' : 'rgba(0, 0, 0, 0.4)') + ''
                }"
              ></li>
            </ul>
          </div>
        </div>
        <div class="common-item flex-a">
          <p>ocuSync:</p>
          <div
            class="signal-wrapper"
          > 
            <span v-show="uavInfo.ocuSync===0||uavInfo.ocuSync===undefined" class="iconfont icon-guanbi1 close flex-fac"></span>
            <ul>
              <li
                v-for="i in 5"
                :key="i"
                :style="{
                  background:
                    '' + (i <= uavInfo.ocuSync ? '#5cf548' : 'rgba(0, 0, 0, 0.4)') + ''
                }"
              ></li>
            </ul>
          </div>
        </div>
      </div>
      <div class="box-middle">
        <p class="item-title">机场信息</p>
        <div class="common-item">
          <p>机场状态:</p>
          <p>{{ airportInfo.nStatusName ? airportInfo.nStatusName : "-" }}</p>
        </div>
        <div class="common-item">
          <p>电池信息:</p>
          <p>
            {{ airportInfo.batteryStatus1 ? airportInfo.batteryStatus1 : "-" }}
          </p>
        </div>
        <div class="common-item">
          <p>电量:</p>
          <p>
            {{
              airportInfo.elecQuantity1 !== undefined
                ? airportInfo.elecQuantity1 + "%"
                : "-"
            }}
          </p>
        </div>
      </div>
      <div class="box-bottom">
        <p class="item-title">任务信息</p>
        <div class="common-item">
          <p>当前任务:</p>
          <p>{{ taskName || "-" }}</p>
        </div>
        <div class="common-item">
          <p>任务状态:</p>
          <p>{{ taskInfo.taskStatusName ? taskInfo.taskStatusName : "-" }}</p>
        </div>
      </div>
    </div>
  </drag-dialog>
</template>

<script setup>
import { ref, toRefs, watch, onMounted, onBeforeUnmount } from "vue";
const props = defineProps({
  isVisible: {
    type: Boolean,
    default: false,
  },
  UAVModel: {
    type: String,
    default: "",
  },
  airportInfo: {
    type: Object,
  },
  uavInfo: {
    type: Object,
  },
  taskInfo: {
    type: Object,
  },
  taskName: {
    type: String,
    default: "",
  },
  websocketsend: {
    type: Function,
  },
});

onMounted(() => {
  const statuMessgae = {
    action: "ACCEPT",
    code: "",
    data: [
      "STA_RTK",
      "STA_AF",
      "STA_GIM",
      "STA_AF_BATTERY",
      "STA_BASIC",
      "STA_N_BATTERY",
      "STA_WP",
      "STA_SIGNAL",
    ],
  };
  props.websocketsend(statuMessgae);
  console.log("打开了状态信息模块");
});
onBeforeUnmount(() => {
  console.log("关闭了状态信息模块");
});
const emit = defineEmits(["update:isVisible"]);
const { isVisible } = toRefs(props);
const dialogVisible = ref(null);
dialogVisible.value = isVisible.value;
watch(dialogVisible, (newProps) => {
  dialogVisible.value = newProps;
  emit("update:isVisible", false);
});
</script>

<style scoped lang="less">
.container {
  height: 26rem;
  overflow: auto;

  .box {
    color: #ffffff;

    .item-title {
      padding: 1.3125rem 0.8125rem 0 0.8125rem;
      font-size: 1rem;
      margin-bottom: 0.9375rem;
    }

    .common-item {
      padding: 0.375rem 0.8125rem;
      display: flex;
      align-items: center;
      justify-content: space-between;

      p {
        font-size: 0.75rem;
      }
    }

    .common-item:last-child {
      border-bottom: 1px solid rgba(35, 163, 236, 0.4);
    }
  }

  .box-middle {
    color: #ffffff;

    .item-title {
      padding: 0.8125rem 0.8125rem 0 0.8125rem;
      font-size: 1rem;
      margin-bottom: 0.4375rem;
    }

    .common-item {
      padding: 0.375rem 0.8125rem;
      display: flex;
      align-items: center;
      justify-content: space-between;

      p {
        font-size: 0.75rem;
      }
    }

    .common-item:last-child {
      border-bottom: 1px solid rgba(35, 163, 236, 0.4);
    }
  }

  .box-bottom {
    color: #ffffff;

    .item-title {
      padding: 0.8125rem 0.8125rem 0 0.8125rem;
      font-size: 1rem;
      margin-bottom: 0.4375rem;
    }

    .common-item {
      padding: 0.375rem 0.8125rem;
      display: flex;
      align-items: center;
      justify-content: space-between;

      p {
        font-size: 0.75rem;
      }
    }
  }
  .signal-wrapper {
    width: 30px;
    height: 15px;
    position: relative;
    .close{
      position: absolute;
      top: 0;
      left: 0;
      color: red;
      width: 8px;
      height: 8px;
      border-radius: 100%;
      background: #fff;
      font-size: 8px;
    }
  }
  ul {
    position: relative;
    width: 100%;
    height: 100%;
  }
  li {
    width: 5px;
    position: absolute;
    bottom: 0;
    border-radius: 10px;
    background: rgba(0, 0, 0, 0.5);
  }
  ul li:nth-child(1) {
    height: 3px;
    left: 0px;
  }
  ul li:nth-child(2) {
    height: 6px;
    left: 6px;
  }
  ul li:nth-child(3) {
    height: 9px;
    left: 12px;
  }
  ul li:nth-child(4) {
    height: 12px;
    left: 18px;
  }
  ul li:nth-child(5) {
    height: 15px;
    left: 24px;
  }
}
</style>
